"use strict";

exports.__esModule = true;
exports.default = void 0;

var _KioskArticleField = _interopRequireDefault(require("./KioskArticleField"));

var _KioskPageField = _interopRequireDefault(require("./KioskPageField"));

var _KioskPageLinkField = _interopRequireDefault(require("./KioskPageLinkField"));

var _KioskAnnotateImageField = _interopRequireDefault(require("./KioskAnnotateImageField"));

var _KioskAnnotateArrayField = _interopRequireDefault(require("./KioskAnnotateArrayField"));

var _KioskModule = _interopRequireDefault(require("./KioskModule"));

var _KioskLink = _interopRequireDefault(require("./KioskLink"));

var _KioskLinkMedia = _interopRequireDefault(require("./KioskLinkMedia"));

var _KioskLinkContent = _interopRequireDefault(require("./KioskLinkContent"));

var _KioskLinkReference = _interopRequireDefault(require("./KioskLinkReference"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "fieldtypes": {},
  "fields": {
    "kioskArticle": _KioskArticleField.default,
    "kioskPage": _KioskPageField.default,
    "kioskPageLink": _KioskPageLinkField.default,
    "kioskAnnotateImage": _KioskAnnotateImageField.default,
    "kioskAnnotateArray": _KioskAnnotateArrayField.default
  },
  "layouts": {
    "kioskModule": _KioskModule.default,
    "kioskLink": _KioskLink.default,
    "kioskLinkMedia": _KioskLinkMedia.default,
    "kioskLinkContent": _KioskLinkContent.default,
    "kioskLinkReference": _KioskLinkReference.default
  },
  "widgets": {}
};
exports.default = _default;
module.exports = exports.default;